export enum feedback_types_enum {
    sucess = "#8DC881",
    warning = "#E2CA64",
    information = "#71C9C1",
    error = "#E29583",
}